import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@tylertech/forge/dist/forge.css';
import './styles/tokens.css';
import './index.css';
import './styles/global.css';
import App from './App.jsx';
import { defineComponents } from '@tylertech/forge';
import { setupTokenInterceptor } from './utils/token';

defineComponents();
setupTokenInterceptor();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);
